import React from 'react';

export function Dot({color}) {
    return (
        <div className={color === "pink" ? "pink-dot dot" : "blue-dot dot"}></div>
    )
}